"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
class AxiosConfig {
    static addHeaders(headers) {
        for (const key of Object.keys(headers)) {
            axios_1.default.defaults.headers.common[key] = headers[key];
        }
    }
    static addHeader(key, value) {
        axios_1.default.defaults.headers.common[key] = value;
    }
    static getHeader(key) {
        return axios_1.default.defaults.headers.common[key];
    }
    static removeHeaders(keys) {
        for (const key of keys) {
            delete axios_1.default.defaults.headers.common[key];
        }
    }
    static removeHeader(key) {
        delete axios_1.default.defaults.headers.common[key];
    }
    static setWithCredentials(value) {
        axios_1.default.defaults.withCredentials = value;
    }
}
exports.default = AxiosConfig;
//# sourceMappingURL=commons.js.map